<template>
	<label
		class="app-floating-label"
		:class="[
			$style['app-floating-label'],
			$style['app-floating-label--dense'],
			{
				[$style['app-floating-label--float-above']]: isFloated,
				[$style['app-floating-label--focused']]: isFocused,
				[$style['app-floating-label--spaced-left']]: withLeftSpacing
			}
		]"
	>
		<span>{{ labelText }}</span>
		<span
			v-if="required"
			:class="$style['app-floating-label__required']"
		>*</span>
	</label>
</template>
<script>
export default {
	name: 'FloatingLabel',
	props: {
		labelText: {
			type: String,
			required: true
		},
		isFloated: {
			type: [Boolean, String],
			required: true
		},
		isFocused: {
			type: [Boolean, String],
			required: true
		},
		withLeftSpacing: {
			type: Boolean,
			default: false
		},
		required: {
			type: [Boolean, String],
			default: false
		}
	},
	watch: {
		labelText () {
			this.$nextTick(() => this.updateNotchWidth())
		},
		isFloated () {
			this.$nextTick(() => this.updateNotchWidth())
		}
	},
	mounted () {
		if (this.isFloated && this.labelText) {
			this.updateNotchWidth()
		} else {
			this.$el.parentElement.style.setProperty('--notch-width', '0px')
		}
		this._resizeObserver = new ResizeObserver(() => {
			// Defer — reading offsetWidth synchronously inside a ResizeObserver
			// callback can crash WebKit on iOS (re-entrant style resolution).
			if (this._notchRafId) return
			this._notchRafId = requestAnimationFrame(() => {
				this._notchRafId = null
				this.updateNotchWidth()
			})
		})
		this._resizeObserver.observe(this.$el)
	},
	beforeDestroy () {
		if (this._resizeObserver) {
			this._resizeObserver.disconnect()
		}
		if (this._notchRafId) {
			cancelAnimationFrame(this._notchRafId)
			this._notchRafId = null
		}
	},
	methods: {
		updateNotchWidth () {
			if (!this.isFloated || !this.labelText) {
				return
			}
			const width = this.$el.offsetWidth * 0.923 + 16
			this.$el.parentElement.style.setProperty('--notch-width', width + 'px')
		}
	}
}
</script>
<style lang="scss" module>
.app-floating-label {
		font-size: 16px;
		line-height: 1.2;
		font-weight: 400;
		letter-spacing: 0.0094em;
		position: absolute;
		bottom: 20px;
		left: 20px;
		right: auto;
		transform-origin: left top;
		transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1),
		color 0.15s cubic-bezier(0.4, 0, 0.2, 1),
		top 0.15s cubic-bezier(0.4, 0, 0.2, 1),
		left 0.15s cubic-bezier(0.4, 0, 0.2, 1);
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor: text;
		overflow: hidden;
		will-change: transform;
		color: getColor(helper-text);
		pointer-events: none;

		&__required {
			color: getColor(danger);
		}

		&--float-above {
			cursor: auto;
			transform: scale(0.75);
		}

		&--dense {
			font-size: 0.813rem;
			bottom: 16px;
			top: 16px;

			&.app-floating-label--float-above {
				top: -7px;
				left: 20px;
				transform: scale(0.923);
			}
		}

		&--focused {
			color: getColor(tertiary);
		}

		&--spaced-left {
			left: 70px;
		}
	}

	.app-floating-label:not(.app-floating-label--float-above) {
		max-width: calc(100% - 55px);
	}
</style>
